/**
 * Linearly interpolates between two numbers.
 * @param start - Value at t=0
 * @param end   - Value at t=1
 * @param t     - Ratio between 0 and 1
 * @returns     - Interpolated value
 */
export const lerp = (start: number, end: number, t: number): number => start * (1 - t) + end * t;
